import { render } from "./Vehicles.vue?vue&type=template&id=a52d2f26"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"
script.render = render

export default script